import * as React from "react";

const Rss: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <path
                d="M32 0v32H0V0h32zM4 4v4.8l.341.003C14.788 8.985 23.2 17.51 23.2 28H28l-.003-.397C27.785 14.531 17.122 4 4 4zm0 9.6v4.8l.273.004C9.45 18.549 13.6 22.79 13.6 28h4.8l-.003-.313C18.23 19.878 11.848 13.6 4 13.6zm2.4 9.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8z"
                fill="#2E5996"
                fillRule="nonzero"
            />
        </svg>
    );
};

export default React.memo(Rss);
